<div data-cy="import-app-modal">
  <div *ngIf="!loading">
    <h2 mat-dialog-title>Application Preview</h2>
    <mat-dialog-content>
      <div [innerHtml]="html" class="tw-pt-3"></div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button color="primary" mat-dialog-close>Cancel</button>
      <button data-cy="save-app-btn" mat-raised-button color="primary" (click)="saveApplication()">Save</button>
    </mat-dialog-actions>
  </div>
  <div *ngIf="loading">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
</div>
